module.exports = __webpack_public_path__ + "static/media/CommentOutline.971224bd.svg";